'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withParams = require('../withParams');

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (equalTo) {
  var $params = { type: 'sameAs', eq: equalTo };
  return (0, _withParams2.default)($params, function (value, parentVm) {
    var compareTo = typeof equalTo === 'function' ? equalTo.call(this, parentVm) : parentVm[equalTo];
    return value === compareTo;
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/validators/sameAs.js
// module id = 784
// module chunks = 0